<template>
	<card class="ReCardTicketAdd">
		<div class="row" >
			<div class="col-lg-7 col-12 order-2 order-lg-1">
				<h4 v-if="bIsNew">Редактирование данных заявки</h4>
				<h4 v-else>Добавление данных заявки</h4>
				
				<hr>
				<ReFormPrinter 
					:masFormConfig="masAllFormParams" 
					:objSaveApiMethod="currentApiFormMethod"		
					:SuccessGo="SuccessGo"
					@value-change="valueChange"/>
			</div>
			<div class="col-lg-5 col-12 order-1 order-lg-2 sticky-container "> 
				<div class="sticky-item ">
					<div v-if="this.objFAQ && this.objFAQ.length > 0" class="faqblock">
						<h4 class="mr-2 mb-0">Часто задаваемые вопросы</h4>
						<ReCardTicketFaq v-for="faq in objFAQ" :key="faq.id" :objFAQ="faq" />
					</div>
				
				</div>
			</div>
		</div>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';

	export default {
		name: 'ReCardTicketAdd',
		components: {
			ReFormPrinter,
			ReCardTicketFaq,
			// [Tooltip.name]: Tooltip,
		},
		props: {
			objTicket: Object,
			findId: {
				type: String,
				default: '',
			},
		},
		watch:{

		},
		data () {
			return {
				ver: 1,
				currentApiFormMethod: this.currentApiFormMethodComp(),
				masAllFormParams: this.currentFormConfig(),
				bShowForm: false,
				fullscreenLoading: false,
				topicTagId: null,
				objFAQ: [],
			}
		},
		computed: {
			bIsNew: function(){
				if(location.pathname.indexOf('/data/ticketsystem/add') == -1){
					return true;
				}
				return false;
			},
			
		},
		methods: {
			
			valueChange(data){
				// console.log('full?',this.fullForm,!this.bIsNew);
				
					// let req = this.getRequiredWatch(data);
					// let reqStr = JSON.stringify(req);
					// if(reqStr!=this.requiredWatch){
					// 	// console.log('form-change', JSON.stringify(data));
					// 	this.requiredWatch = reqStr;
					// 	this.updateRequiredFields(req);
					// }
					// console.log('valueChange',data.topicTag);
					this.objFAQ=[];
					if(data.topicTag && data.topicTag!=''){
						this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {topicTag:data.topicTag} })
						.then((objApi) => {
							if(objApi.success === true){
								if(objApi.data.length > 0){
									this.objFAQ = objApi.data;
									// console.log('this.objFAQ',this.objFAQ);
									// if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
								}
							}else{
								this.objFAQ = [];
								// this.masApi_total=0;
							}
						}).catch(errorObjApi => {this.objFAQ = []; console.error(errorObjApi);});

					}
				
			},
			currentApiFormMethodComp(){
				return {apiMethod:'INS',apiParam:{obj:'TicketSystem' ,flt:{},iData:[]}};
			},
			currentFormConfig(){
				this.$GVO.ApiCall('GET_FORM',{obj:'TicketSystem',flt:{}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
				return [];
			},
			SuccessGo(evt,dopParam){
				if(location.pathname.indexOf('/data/ticketsystem/add') != -1){
					// console.log('SuccessGo',evt,dopParam,typeof dopParam.data.new_id);
					if(typeof dopParam.data.new_id != 'undefined'){
						location.href = '/data/ticketsystem/id/'+dopParam.data.new_id;
					}else{
						location.href = '/data/ticketsystem';
					}
				}else{
					location.href = this.$GVO.str_replace('/edit','',evt);
				}
			},
		},

		mounted() {
			
		},
	}
</script>
<style scoped>
	.ReCardTicketAdd hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
	}
	.ReCardTicketAdd >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
	.ReCardTicketAdd .badge {font-size: 0.7rem; height: fit-content;}
	.ReCardTicketAdd >>>  .sticky-container {position: relative;    margin-top: 40px;}
	.ReCardTicketAdd >>>  .sticky-item {display: flex; flex-direction: column; position: sticky; top: 15px; z-index: 2; background: inherit;}
	.ReCardTicketAdd .faqblock {
		border: 1px dashed #BA54F5;
		border-radius: 6px;
		padding: 15px;
	}
</style>
